@if (detailStore.loading()) {
  <section class="ingest-detail">
    <div class="loading-container">
      <lib-empty message="Cargando expediente" description="Espere por favor..." />
    </div>
  </section>
}

@if (!detailStore.loading() && detailStore.error()) {
  <section class="ingest-detail">
    <p class="ingest-detail__error">{{ detailStore.error() }}</p>
    <lib-button variant="secondary" type="button" prefixIcon="ArrowLeft" (clicked)="goBack()">
      Volver a la lista
    </lib-button>
  </section>
}

@if (!detailStore.loading() && !detailStore.error() && detailStore.project(); as p) {
  <section class="ingest-detail">
    <app-page-header
      [title]="p.name"
      subtitle="Detalle del expediente, carpetas y rutas de ingesta."
      icon="Folder"
      [actions]="headerActions()"
      (actionClick)="onHeaderAction($event)"
      />
    @if (inactiveProjectMessage(); as inactiveMessage) {
      <p class="ingest-detail__notice" role="status">{{ inactiveMessage }}</p>
    }
    <dl class="ingest-detail__dl">
      <dt>Descripción</dt>
      <dd>{{ p.description || '—' }}</dd>
      <dt>Carpeta</dt>
      <dd>{{ p.folder_path || '—' }}</dd>
      <dt>Estado</dt>
      <dd>
        <span class="ingest-detail__badge" [class.ingest-detail__badge--off]="!p.is_active">
          {{ p.is_active ? 'Activo' : 'Inactivo' }}
        </span>
      </dd>
      <dt>ID</dt>
      <dd>{{ p.id }}</dd>
    </dl>
    <hr class="ingest-detail__separator" />
    <section class="ingest-detail__subfolders">
      <h3>Subcarpetas</h3>
      <div class="ingest-detail__subfolder-create">
        <div class="ingest-detail__subfolder-actions">
          @if (canModifyProject()) {
            <lib-button
              variant="primary"
              type="button"
              [loading]="detailStore.creatingSubfolder()"
              (clicked)="createSubfolder()"
              >
              Crear subcarpeta
            </lib-button>
          }
          <lib-button
            variant="secondary"
            type="button"
            prefixIcon="RefreshCcw"
            [loading]="detailStore.loadingSubfolders()"
            (clicked)="loadSubfolders()"
            >
            Actualizar
          </lib-button>
        </div>
        @if (canModifyProject()) {
          <app-grid-form preset="responsive" wrapperClass="ingest-detail__subfolder-grid">
            <app-grid-form-item [span]="2" class="ingest-field">
              <app-field-label
                label="Nueva subcarpeta"
                tooltip="Letras, números, - y _. Los espacios se convierten automáticamente en _. El carácter / no está permitido."
                />
              <lib-input
                label=""
                placeholder="Ej: caja_dos o nuevo-prueba"
                [value]="newSubfolderName"
                (valueChange)="onNewSubfolderNameChange($event)"
              />
            </app-grid-form-item>
          </app-grid-form>
        }
      </div>
      @if (detailStore.loadingSubfolders()) {
        <p class="ingest-detail__hint">Cargando subcarpetas…</p>
      }
      @if (detailStore.subfoldersError()) {
        <p class="ingest-detail__error">{{ detailStore.subfoldersError() }}</p>
      }
      @if (!detailStore.loadingSubfolders() && !detailStore.subfoldersError() && detailStore.subfolders().length > 0) {
        <ul class="ingest-detail__list">
          @for (item of detailStore.subfolders(); track item) {
            <li>
              <code>{{ formatIngestSubfolderDisplay(item) }}</code>
            </li>
          }
        </ul>
      }
      @if (!detailStore.loadingSubfolders() && !detailStore.subfoldersError() && detailStore.subfolders().length === 0) {
        <p class="ingest-detail__hint">
          No hay subcarpetas registradas.
        </p>
      }
    </section>
  </section>
}
